/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetEntityFilesQuery } from '../../models/get-entity-files-query';
import { QueryResultOfIEnumerableOfEntityFileInfo } from '../../models/query-result-of-i-enumerable-of-entity-file-info';

export interface IdentGetEntityFiles$Params {
      body: GetEntityFilesQuery
}

export function identGetEntityFiles(http: HttpClient, rootUrl: string, params: IdentGetEntityFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultOfIEnumerableOfEntityFileInfo>> {
  const rb = new RequestBuilder(rootUrl, identGetEntityFiles.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryResultOfIEnumerableOfEntityFileInfo>;
    })
  );
}

identGetEntityFiles.PATH = '/ident/entity_files';
